import SouhuoList from '@/components/puppetComponent/SouhuoList'
import SegementLine from '@/components/puppetComponent/SegementLine'
import QuickTop from '@/components/smartComponent/QuickTop'
import RowList from '../children/RowList'
import FlashSale from '../children/FlashSale'
import FlashSaleList from '../children/FlashSaleList'
import TimeScrroll from '../children/TimeScrroll'
import FilterRadio from '../children/FilterRadio'
import { Toast, Indicator } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'
import { loginSouhuoList, noLoginSouhuoList } from '@/api/souhuo'
import {
  // CheckExChange,
  ZeroYuanFutureNodeBuyingPage,
  ZeroYuanFutureNodeBuyingNoLogin,
  // GetBannerRushBuyList,
  // GetBannerRushBuyListNoLogin,
  GetRushBuyList,
  GetRushBuyListNoLogin
} from '@/api/zeroBuy'
import { ProductFavoriteAdd, IsSetRemind } from '@/api/remind'
import Utils from '@/utils/base'

export default {
  data() {
    return {
      isLastOne: false,
      haveMore: true,
      isReturn: false,
      scrollDisabled: false,
      container: null,
      pageScrollTop: 0,
      dataList: [],
      isFirstPage: true,
      isFakeSkeleton: true,
      isFetched: false, // 是否为第一次请求
      bsScroll: null,
      // 是否吸顶
      isFixed: false,
      fixedTop: 0,
      timeList: [],
      currentTimeIndex: 0,
      // 是否为当前时间节点
      isCurrentTime: true,
      // 当前时间tab
      currentTabNode: null,
      // 抢购模块
      flashSaleDataList: [],
      flashSaleListDataList: [], // 热销模块（原抢购模块）
      // 剩余抢购时间
      residueTime: 0,
      // 筛选
      SAPPHomeSortType: 0,
      platformShopType: null, // 店铺类型筛选 1-天猫，2-拼多多
      filterRadioBoxElem: null,
      isNewcomer: false // 是否是新人
    }
  },
  components: {
    SouhuoList,
    SegementLine,
    QuickTop,
    RowList,
    TimeScrroll,
    FilterRadio,
    FlashSale,
    FlashSaleList
  },
  computed: {
    ...mapGetters(['loginState', 'getIsApp', 'getIsAuthorized', 'getTabBarZeroBadge'])
  },
  mounted() {
    this.$nextTick(() => {
      // 绑定监听事件
      this.container = document.getElementsByClassName('container')[0]
      this.container.addEventListener('scroll', this.handleScroll)
      this.filterRadioBoxElem = document.querySelector('#sch-child')
      this.fixedTop = this.filterRadioBoxElem.offsetTop
    })
  },
  methods: {
    ...mapMutations(['AUTHORIZE_POPUP_SHOW', 'SET_IF_SHOW_APP_DOWNLOAD_GUIDE', 'SET_IF_SHOW_APP_RESERVE_REMIND']),
    reFetchPage(from) {
      let routeNames = ['goodsDetail', 'freeCardDetail']
      if (routeNames.indexOf(from.name) !== -1 && this.container) {
        this.$nextTick(() => {
          this.container.scrollTop = this.pageScrollTop
        })
      } else {
        this.isNewcomer = Utils.getNewcomerStorage()
        this.dataList = []
        this.flashSaleListDataList = []
        this.dataList.splice(0)
        this.pageScrollTop = 0
        this.isFakeSkeleton = true
        this.isFixed = false
        this.isReturn = false
        this.isLastOne = false
        this.isFirstPage = true
        this.currentTimeIndex = 0
        this.isCurrentTime = true
        this.SAPPHomeSortType = 0
        this.platformShopType = null
        if (this.$refs.filterRadioRef) this.$refs.filterRadioRef.reset()
        this.$nextTick(() => {
          if (this.$refs.timeScroll && this.$refs.timeScroll.bsScroll) this.$refs.timeScroll.bsScroll.scrollTo(0, 0, 200)
        })
        this.fetchData()
        if (this.loginState) {
          this.$store.dispatch('waitGetFreeCarNum_Action', {
            isSearchTotal: true
          })
        }
      }
    },
    fetchData(isDropDown = false) {
      let params = {
        DropDown: isDropDown,
        SAPPHomeSortType: this.SAPPHomeSortType,
        ShopType: this.platformShopType,
        IsHomePage: true,
        IsFreeCard: true,
        IsNewPerson: this.isNewcomerPage
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      this.isFirstPage = !isDropDown
      if (this.loginState) {
        loginSouhuoList(params)
          .then((res) => {
            this.handlerFetchSuccess(res)
            // if (!isDropDown) this.fetchFlashSale()
          })
          .catch((err) => {
            this.handlerFetchErr(err)
          })
      } else {
        noLoginSouhuoList(params)
          .then((res) => {
            this.handlerFetchSuccess(res)
            // if (!isDropDown) this.fetchFlashSale()
          })
          .catch((err) => {
            this.handlerFetchErr(err)
          })
      }
    },
    // 获取未来节点数据
    fetchTimeNodeList(isDropDown = false) {
      if (!this.currentTabNode) return
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let postData = {
        DropDown: isDropDown,
        RemindNode: this.currentTabNode.Node,
        Gapday: this.currentTabNode.GapDay,
        IsNewPerson: this.isNewcomerPage,
        ShopType: this.platformShopType,
        SAPPHomeSortType: this.SAPPHomeSortType
      }
      this.scrollDisabled = true
      if (this.loginState) {
        ZeroYuanFutureNodeBuyingPage(postData)
          .then((res) => {
            this.handlerTimeNodeSuccess(res)
            // if (!isDropDown) this.fetchFlashSale()
          })
          .catch((err) => {
            this.handlerFetchErr(err)
          })
      } else {
        ZeroYuanFutureNodeBuyingNoLogin(postData)
          .then((res) => {
            this.handlerTimeNodeSuccess(res)
            // if (!isDropDown) this.fetchFlashSale()
          })
          .catch((err) => {
            this.handlerFetchErr(err)
          })
      }
    },
    // // 获取抢购模块商品
    // fetchFlashSale (isShowLoading = false) {
    //   if (isShowLoading) {
    //     Indicator.open({
    //       text: '加载中',
    //       spinnerType: 'triple-bounce'
    //     })
    //   }
    //   if (this.loginState) {
    //     GetBannerRushBuyList().then(res => {
    //       this.handlerFlashSaleSuccess(res)
    //     }).catch(err => {
    //       Indicator.close()
    //       Toast(err.ErrMsg)
    //     })
    //   } else {
    //     GetBannerRushBuyListNoLogin().then(res => {
    //       this.handlerFlashSaleSuccess(res)
    //     }).catch(err => {
    //       Indicator.close()
    //       Toast(err.ErrMsg)
    //     })
    //   }
    // },
    // 获取热销节点数据
    fetchFlashSaleList(isDropDown = false) {
      let params = {
        DropDown: isDropDown,
        IsNewPerson: this.isNewcomerPage,
        SAPPHomeSortType: this.SAPPHomeSortType
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      if (this.loginState) {
        GetRushBuyList(params)
          .then((res) => {
            this.handlerFlashSaleListSuccess(res)
          })
          .catch((err) => {
            this.handlerFlashListErr(err)
          })
      } else {
        GetRushBuyListNoLogin(params)
          .then((res) => {
            this.handlerFlashSaleListSuccess(res)
          })
          .catch((err) => {
            this.handlerFlashListErr(err)
          })
      }
    },
    // 处理当前时间节点返回数据
    handlerFetchSuccess(res) {
      this.isFetched = true
      this.dataList = [...this.dataList, ...res.DataList]
      this.timeList = res.RemindNodeList
      this.isLastOne = res.BoolSID
      this.isFakeSkeleton = false
      if (res.BoolSID) {
        this.haveMore = false
      } else {
        this.haveMore = true
      }
      this.scrollDisabled = false
      Indicator.close()
      //   if (this.isCurrentTime === true && this.flashSaleDataList.length > 0 && this.isFirstPage) {
      //     this.$nextTick(() => { this.fixedTop = document.querySelector('.filter-radio-box').offsetTop })
      //   }
    },
    // 处理未来时间节点返回数据
    handlerTimeNodeSuccess(res) {
      const { DataList, BoolSID, IfShowAppDownloadGuide, IfShowAppReserveRemind } = res
      this.SET_IF_SHOW_APP_DOWNLOAD_GUIDE(IfShowAppDownloadGuide)
      this.SET_IF_SHOW_APP_RESERVE_REMIND(IfShowAppReserveRemind)
      if (this.currentTabNode.Node === '23:00') {
        // 由于23点后免单商品都只需要1张免单卡就可以兑换，则0元专区中23点节点的商品，都直接展现为【1张免单卡】的样式
        DataList.forEach((val) => {
          val.FreeCardNum = 1
        })
      }
      this.isFetched = true
      this.dataList = [...this.dataList, ...DataList]
      this.isLastOne = BoolSID
      if (BoolSID) {
        this.haveMore = false
      } else {
        this.haveMore = true
      }
      this.scrollDisabled = false
      Indicator.close()
    },
    // // 处理抢购模块返回数据
    // handlerFlashSaleSuccess (res) {
    //   Indicator.close()
    //   let data = res.data
    //   let handlerData = []
    //   let start = 0
    //   if (data.length > 0) {
    //     for (let i = 0; i < Math.ceil(data.length / 4); i++) {
    //       handlerData.push(data.slice(start, start + 4))
    //       start += 4
    //     }
    //   }
    //   this.flashSaleDataList = handlerData
    //   this.residueTime = res.residueTime
    //   if (this.isCurrentTime === true && this.flashSaleDataList.length > 0) {
    //     this.$nextTick(() => { this.fixedTop = document.querySelector('.filter-radio-box').offsetTop })
    //   }
    // },
    // 处理热销节点模块返回数据
    handlerFlashSaleListSuccess(res) {
      this.isFetched = true
      this.flashSaleListDataList = [...this.flashSaleListDataList, ...res.DataList]
      this.isLastOne = res.BoolSID
      if (res.BoolSID) {
        this.haveMore = false
      } else {
        this.haveMore = true
      }
      this.scrollDisabled = false
      Indicator.close()
      // if (this.isCurrentTime === 'flashSale' && res.ResidueTime <= 0) {
      //   let instance = Toast('限时抢购结束啦，欢迎在下个整点再来参加哦~')
      //   setTimeout(() => {
      //     instance.close()
      //     this.residueTime = 0
      //     this.currentTimeIndex = 0
      //     this.isCurrentTime = true
      //     this.fetchData()
      //   }, 2000)
      // }
    },
    handlerFetchErr(err) {
      this.isFetched = true
      this.haveMore = false
      Indicator.close()
      if (err.ErrMsg) {
        Toast(err.ErrMsg)
      }
    },
    handlerFlashListErr(err) {
      this.isFetched = true
      this.haveMore = false
      Indicator.close()
      if (err.ErrMsg === '当前限时抢购已结束') {
        let instance = Toast('限时抢购结束啦，欢迎在下个整点再来参加哦~')
        setTimeout(() => {
          instance.close()
          this.residueTime = 0
          this.currentTimeIndex = 0
          this.isCurrentTime = true
          this.fetchData()
        }, 2000)
      } else {
        if (err.ErrMsg) {
          Toast(err.ErrMsg)
        }
      }
    },
    // 时间节点点击切换
    timeScrollClick(index) {
      if (this.currentTimeIndex === index) return
      this.currentTimeIndex = index
      this.currentTabNode = this.timeList[index]
      this.dataList = []
      this.flashSaleListDataList = []
      // 进入每个节点时默认选中综合
      this.platformShopType = null
      this.ShopType = null
      this.SAPPHomeSortType = 0
      this.$refs.filterRadioRef.reset()
      if (index === 0) {
        this.isCurrentTime = true
        this.isFakeSkeleton = true
        this.fetchData()
      } else if (index === this.timeList.length) {
        // 热销模块（原 限时抢购）
        this.isCurrentTime = 'flashSale'
        this.isFetched = false
        this.fetchFlashSaleList()
      } else {
        // 未来时间节点
        this.isCurrentTime = false
        this.isFetched = false
        this.fetchTimeNodeList()
      }
    },
    // 筛选
    filterChange(val, sort) {
      if (this.isFixed) this.container.scrollTop = document.querySelector('.zero-time-scroll').offsetTop
      this.dataList = []
      this.flashSaleListDataList = []
      this.SAPPHomeSortType = null
      if (val === 'comprehensive') {
        this.SAPPHomeSortType = 0
      } else if (val === 'new') {
        this.SAPPHomeSortType = 8
      } else if (val === 'freeCard') {
        // SAPPHomeSortType:6 免单卡数量从多到少
        if (sort === 'asc') this.SAPPHomeSortType = 7
        else this.SAPPHomeSortType = 6
      }
      this.haveMore = true
      if (this.isCurrentTime === 'flashSale') {
        this.fetchFlashSaleList()
      } else if (this.isCurrentTime) {
        this.fetchData()
      } else {
        this.fetchTimeNodeList()
      }
    },
    // 平台筛选
    platformChange(platformShopType) {
      if (this.isFixed) this.container.scrollTop = document.querySelector('.zero-time-scroll').offsetTop
      this.dataList = []
      this.platformShopType = platformShopType
      this.haveMore = true
      if (this.isCurrentTime) {
        this.fetchData()
      } else {
        this.fetchTimeNodeList()
      }
    },
    // 兑换商品/进入详情页
    convertShop(productId) {
      this.$router.push({
        name: 'goodsDetail',
        query: {
          productID: productId,
          isFreeCard: true
        }
      })
    },
    // 检测登录
    checkLogin(fn) {
      if (this.loginState) {
        if (fn) fn()
      } else {
        this.unLoginModal()
      }
    },
    unLoginModal() {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    },
    // 加入收藏夹
    remindMe(index, productId) {
      if (!this.loginState) {
        this.unLoginModal()
        return
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      ProductFavoriteAdd({
        productId: productId
      })
        .then((res) => {
          Indicator.close()
          this.$set(this.dataList[index], 'IsFavorite', true)
          Toast('已加入收藏夹')
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg) {
            Toast(err.ErrMsg)
          }
        })
    },
    // 取消收藏
    cancelRemind(index, productId) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      IsSetRemind({
        productId: productId
      })
        .then((res) => {
          Indicator.close()
          this.$set(this.dataList[index], 'IsFavorite', false)
          Toast('已取消收藏')
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg) {
            Toast(err.ErrMsg)
          }
        })
    },
    // // 抢购查看全部
    // goFlashSaleList (index) {
    //   this.isCurrentTime = 'flashSale'
    //   this.currentTimeIndex = index
    //   this.$nextTick(() => {
    //     if (this.$refs.timeScroll) this.$refs.timeScroll.bsScroll.scrollTo(0, 0, 200)
    //   })
    //   this.fetchFlashSaleList()
    // },
    // 返回顶部
    returnTop() {
      this.container.scrollTop = 0
    },
    // 滚动监听
    handleScroll(e) {
      // 滚动高度
      let scrollTop = this.container.scrollTop
      this.pageScrollTop = scrollTop || 0
      // 屏幕高度
      let documentH = document.documentElement.clientHeight || document.body.clientHeight
      if (scrollTop > documentH) {
        this.isReturn = true
      } else {
        this.isReturn = false
      }
      this.isFixed = scrollTop > this.fixedTop
    },
    loadMore() {
      if (!this.isFetched) return
      if (this.isLastOne) {
        this.haveMore = false
        return
      }
      this.haveMore = true
      if (this.isCurrentTime === true) {
        this.fetchData(true)
      } else if (this.isCurrentTime === 'flashSale') {
        this.fetchFlashSaleList(true)
      } else {
        this.fetchTimeNodeList(true)
      }
    }
  },
  watch: {
    loginState: {
      handler(val) {
        if (val) {
          this.$store.dispatch('waitGetFreeCarNum_Action', {
            isSearchTotal: true
          })
        }
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.reFetchPage(from)
    })
  }
}
